import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import GlobalVariable from "../../../../services/globalVar";
import { Tag } from "antd";

const EstimateDetails = (props) => {
  const parentData = props;

  const dueDateFormBodyTemplate = (rowData) => {
    return (
      <div>
        {format(
          new Date(rowData.estimateDate),
          GlobalVariable.userDet.tenantConfig.dateFormat
        )}
      </div>
    );
  };

  const nameFormBodyTemplate = (rowData) => {
    return rowData.firstName + " " + rowData.lastName;
  };
  const amountBodyStatusTemplate = (rowData) => {
    let status = rowData.status?.toUpperCase();
    let statusClass;
    switch (status) {
      case "DRAFT":
        statusClass = "#f0f0f0";
        break;
      case "ESTIMATED":
        statusClass = "#c7ecc7";
        break;
      case "EXPIRED":
        statusClass = "rgb(255 227 227)";
        break;
      case "REJECTED":
        statusClass = "rgb(255 145 145)";
        break;
      case "INVOICED":
        statusClass = "#d5f7d5";
        break;
      default:
        statusClass = "#ffffff";
        break;
    }
    return (
      <Tag bordered={false} color={statusClass}>
        {status}
      </Tag>
    );
  };
  return (
    <div className="card">
      <DataTable
        value={parentData.estimateDetails}
        tableStyle={{ minWidth: "100%" }}
      >
        <Column field="estimateNumber" header="Estimate Number"></Column>
        <Column
          field="dueDateFormBodyTemplate"
          header="Estimate Date"
          body={dueDateFormBodyTemplate}
        ></Column>
        <Column field="companyName" header="Company Name"></Column>
        <Column
          field="nameFormBodyTemplate"
          header="Customer Name"
          body={nameFormBodyTemplate}
        ></Column>
        <Column
          field="totalAmount"
          header="Amount"
          className="text-end amount-align"
          body={(a) => parentData.currency + " " + a.totalAmount.toFixed(2)}
        ></Column>
        {/* <Column
          field="totalAmount"
          header="Status"
          body={(e) => amountBodyStatusTemplate(e)}
        ></Column> */}
      </DataTable>
    </div>
  );
};

export default EstimateDetails;
